/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostPatientCustomTokenResponseTypename = "PostPatientCustomTokenResponse" as const;

/**
 *
 * @export
 * @interface PostPatientCustomTokenResponse
 */
export interface PostPatientCustomTokenResponse {
  /**
   *
   * @type {string}
   * @memberof PostPatientCustomTokenResponse
   */
  customToken?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostPatientCustomTokenResponse
   */
  readonly __typename?: string;
}

export function PostPatientCustomTokenResponseFromJSON(json: any): PostPatientCustomTokenResponse {
  return PostPatientCustomTokenResponseFromJSONTyped(json, false);
}

export function PostPatientCustomTokenResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostPatientCustomTokenResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostPatientCustomTokenResponseTypename,

    customToken: !exists(json, "custom_token") ? undefined : json["custom_token"],
  };
}

export function PostPatientCustomTokenResponseToJSON(object?: PostPatientCustomTokenResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    custom_token: value.customToken,
  };
}
